<template>
  <div>
    <TopBar :page="topBarData" @addBtnClick="addBtnClicked"/>
    <v-container fluid>
      <v-row>
        <v-col>
          <ProductListTable />
        </v-col>
      </v-row>
    </v-container>
    <ProductListFilter :openFilter="openFilter" @closeDialog="openFilter=false;" />
  </div>
</template>

<script>
import ProductListTable from "@/components/Products/ProductList/ProductListTable";
import ProductListFilter from "@/components/Products/ProductList/ProductListFilter";
import TopBar from "@/components/Layout/TopBar";

export default {
  components: {
    ProductListTable,
    ProductListFilter,
    TopBar
  },
  
  data() {
    return {
      topBarData: {
        name: 'Products',
        type: 'productList',
        showSearch: true,
        menu: false,
        breadcrumbs: [],
        additionalButtons: [
          {
            inner: 'filter',
            color: 'secondary',
            method: 'openFilter',
          }
        ],
        showBeehiveIcon: false,
      },
      openFilter: false
    }
  },

  methods: {
    addBtnClicked(btnName){
      switch(btnName){
        case 'openFilter':
          this.openFilter = true;
          break
      }
    },
  },
}
</script>

<style>

</style>
